import { render } from "./newTableLite.vue?vue&type=template&id=ad824636"
import script from "./newTableLite.vue?vue&type=script&lang=js"
export * from "./newTableLite.vue?vue&type=script&lang=js"

import "./newTableLite.vue?vue&type=style&index=0&id=ad824636&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__